"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rollout = exports.breathe = void 0;

var breathe = function breathe() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.25;
  return "\n        @keyframes breathe {\n            0% {\n                transform: scale(".concat(min, ");\n            };\n            50% {\n                transform: scale(").concat(max, ");\n            };\n            100%{\n                transform: scale(").concat(min, ");\n            };\n        };\n    ");
};

exports.breathe = breathe;

var rollout = function rollout() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "100%";
  var finish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0";
  return "\n        @keyframes rollout {\n            0% {\n                transform: translateX(".concat(start, ");\n            }\n            100% {\n                transform: translateX(").concat(finish, ");\n            }\n        };\n    ");
};

exports.rollout = rollout;